import _ from "lodash";
import axios from "axios";
import store from "../store";

let APIURL = process.env.VUE_APP_API_URL;

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const API = axios.create({
    baseURL: APIURL,
    timeout: 50000
});

const POST = (uri, params, headers = {}) => {
    return new Promise((resolve, reject) => {
        API.post(uri, params, { headers })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                error = error.response;
                let errors = {};

                switch (error.status) {
                    case 422:
                        _.each(
                            error.data,
                            (item, key) => (errors[key] = _.head(item))
                        );

                        reject({
                            status: error.status,
                            errors
                        });

                        break;
                    case 404:
                    case 401:
                        reject({
                            status: error.status,
                            errors: {
                                message: error.data.message
                            }
                        });
                        break;
                    case 419:
                        store.commit("auth/logout");
                        break;
                    case 400:
                        reject({
                            status: error.status,
                            errors: {
                                message: error.data.message
                            }
                        });
                        break;
                    default:
                        reject({
                            status: 500,
                            errors: {
                                message:
                                    "Something went wrong, please try again"
                            }
                        });
                }
            });
    });
};

const GET = (uri, headers = null) => {
    return new Promise((resolve, reject) => {
        API.get(uri, {
            headers
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                error = error.response;
                switch (error.status) {
                    case 400:
                    case 404:
                    case 401:
                        reject({
                            status: error.status,
                            errors: {
                                message: error.data.message
                            }
                        });
                        break;
                    case 419:
                        store.commit("auth/logout");
                        break;
                    default:
                        reject({
                            status: 500,
                            errors: {
                                message:
                                    "Something went wrong, please try again"
                            }
                        });
                }
            });
    });
};

export default {
    post: POST,
    get: GET
};
